import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

/**
 * PhoneInput - country code dropdown (+1, +509) + phone number input
 */
export const PhoneInput = ({ phoneCode, phone, onChange, label, required = false, testPrefix = "phone" }) => {
    const [countries, setCountries] = useState([]);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/api/countries");
                setCountries(data || []);
            } catch {}
        })();
    }, []);

    const codes = countries.length
        ? countries.map((c) => c.phone_code)
        : ["+1", "+509"];

    return (
        <div>
            {label && (
                <label className="text-sm font-semibold text-foreground block mb-1.5">
                    {label}
                    {required ? " *" : ""}
                </label>
            )}
            <div className="flex gap-2">
                <select
                    data-testid={`${testPrefix}-code`}
                    value={phoneCode || "+1"}
                    onChange={(e) => onChange({ phone_code: e.target.value, phone })}
                    className="input-modern !w-auto !py-3 !pr-8 !pl-3 font-semibold"
                >
                    {codes.map((c) => (
                        <option key={c} value={c}>
                            {c}
                        </option>
                    ))}
                </select>
                <input
                    data-testid={`${testPrefix}-number`}
                    type="tel"
                    value={phone || ""}
                    onChange={(e) =>
                        onChange({ phone_code: phoneCode || "+1", phone: e.target.value })
                    }
                    className="input-modern flex-1"
                    placeholder="555 000 1234"
                />
            </div>
        </div>
    );
};
